// removed by extract-text-webpack-plugin
module.exports = {"form":"c-ChangePasswordForm__form","fields":"c-ChangePasswordForm__fields","wrapper":"c-ChangePasswordForm__wrapper","button":"c-ChangePasswordForm__button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ChangePasswordForm/ChangePasswordForm.scss
// module id = 727
// module chunks = 0